module.exports = __webpack_public_path__ + "static/TuktukRed-2b6f56c09070f0feb69f16941c5a53d3.webm";